import { view } from "@/mega-ui/helpers/function"
import { getAuthenticationStore } from "@/helpers/storeHelpers"

export const home = {
    path: '',
    name: 'home',
    meta: {
        withProducts: true
    },
    beforeEnter: () => {
        const authStore = getAuthenticationStore()
        if (!authStore || !authStore.isAuthenticated) {
            authStore?.logout()
            return { name: 'login-main' }
        }
        
        return true
    },
    component: () => view('home/HomeView')
}